import React from 'react';
import { Lang } from 'shared/constants';
import { Modal, TextAreaInput } from 'src/components/design-system';
import { debounce } from 'lodash';

const AdmissionChecklistCommentComponent = React.memo(function AdmissionChecklistCommentComponent({
  open = false,
  item,
  lang = Lang.ADMISSION_COMMENT,
  updateComment = () => {},
  onFinish = () => {},
  comment = '',
  categoryId = null,
}) {
  item = item ?? {};
  const onChangeText = debounce(text => {
    updateComment({
      comment: text,
      categoryId,
      id: item.id,
    });
  }, 1000);

  const onChange = e => {
    onChangeText(e.target.value);
  };

  return (
    <Modal
      title={lang.HEADER.replace('{name}', item.title ?? '')}
      open={open}
      onCancel={onFinish}
      cancelText={lang.DISMISS}>
      <TextAreaInput label={lang.INFO} defaultValue={comment} onChange={onChange} rows={8} />
    </Modal>
  );
});

export { AdmissionChecklistCommentComponent };
